<template>
  <div>
    <placeholder v-if="hasError" />
    <a :href="href">
      <img :src="imageContent.url" :alt="imageContent.altText"/>
    </a>
  </div>
</template>

<script>
  import Content from "./image-content";
  import Placeholder from "../placeholder/Placeholder";
  import { Props, Computed } from '../../assets/js/mixins';

  let imageContent;

  export default {
    mixins: [Props, Computed],
    data() {
      return {
        hasError: false,
        imageContent: {}
      }
    },
    computed: {
      href() {
        if (this.imageContent.link) {
          return this.imageContent.link
        } else {
          return '#'
        }
      },
      hasContentUrl() {
        if (typeof this.content === 'string') {
          return true;
        } else {
          return false;
        }
      }
    },
    created() {
      if (this.hasContentUrl) {
        imageContent = new Content(this.content);
      }
    },
    beforeMount() {
      if (this.hasContentUrl) {
        let vm = this;
        imageContent.formatImageContent().then(() => {
          vm.imageContent = imageContent.content
        }, () => {
          vm.hasError = true;
        });
      } else {
        this.imageContent = this.content
      }
    },
    components: {
      Placeholder
    }
  }
</script>

<style lang="scss" scoped>
  img {
    width: 100%;
    height: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/image/Image.vue